export const SUBMIT_CONTACT_FORM = 'SUBMIT_CONTACT_FORM'
export const SUBMIT_CONTACT_FORM_FAILED = 'SUBMIT_CONTACT_FORM_FAILED'
export const RESET_SUBMIT_CONTACT_FORM_STATE = 'RESET_SUBMIT_CONTACT_FORM_STATE'